import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ShieldOff } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAccessGuardStore } from '@/store'

export const AccessDeniedOverlay = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { isAccessDenied, statusCode, message, clearAccessDenied } =
        useAccessGuardStore()
    const previousPathRef = useRef(location.pathname)

    useEffect(() => {
        if (isAccessDenied && previousPathRef.current !== location.pathname) {
            clearAccessDenied()
        }
        previousPathRef.current = location.pathname
    }, [location.pathname, isAccessDenied, clearAccessDenied])

    if (!isAccessDenied) {
        return null
    }

    const fallbackMessage =
        'You do not have access to view this page. Thank you.'
    const responseMessage =
        message && message !== fallbackMessage ? message : undefined
    // const requestPath = path || location.pathname

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
            <div className="w-full max-w-lg rounded-lg bg-white p-8 shadow-2xl">
                <div className="flex items-start gap-3">
                    <div className="rounded-full bg-red-100 p-3">
                        <ShieldOff className="h-6 w-6 text-red-600" />
                    </div>
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-red-700">
                            Access restricted
                        </p>
                        <h2 className="text-xl font-semibold text-gray-900">
                            You do not have access to view this
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            {fallbackMessage}
                        </p>
                        {responseMessage && (
                            <p className="text-xs text-muted-foreground">
                                Server response: {responseMessage}
                            </p>
                        )}
                    </div>
                </div>

                <div className="mt-4 rounded-md bg-gray-50 px-4 py-3 text-xs text-muted-foreground">
                    <div className="flex items-center gap-2">
                        <span className="font-medium text-gray-800">
                            Request
                        </span>
                        {statusCode && (
                            <span className="rounded-full bg-red-100 px-2 py-0.5 text-[11px] font-semibold text-red-700">
                                {statusCode}
                            </span>
                        )}
                    </div>
                    {/* <p className="mt-1 break-words font-mono text-[11px] text-gray-700">
                        {requestPath}
                    </p> */}
                </div>

                <div className="mt-6 flex flex-wrap gap-3">
                    <Button
                        className="min-w-[200px] flex-1 gap-2"
                        onClick={() => {
                            clearAccessDenied()
                            navigate('/')
                        }}
                    >
                        Return to dashboard
                    </Button>
                    <Button
                        variant="outline"
                        className="min-w-[200px] flex-1"
                        onClick={clearAccessDenied}
                    >
                        Dismiss
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AccessDeniedOverlay
